/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $OnboardingProfessionStatus = {
  type: 'Enum',
} as const;
